module.exports = __webpack_public_path__ + "img/ic-quality-check-green.b8d6c901.svg";